var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-16 pb-24"},[_c('div',{staticClass:"w-auto h-full mx-4 my-0 wrapper lg:max-w-6xl xl:mx-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }